var exports = {
  "dL": "GuildHeader.module__headerWrapper___cVA5c0",
  "N1": "GuildHeader.module__headerContainer___cVA5c0",
  "bp": "GuildHeader.module__headerContainerActive___cVA5c0",
  "vf": "GuildHeader.module__headerContainerBanner___cVA5c0",
  "Le": "GuildHeader.module__headerContainerCollapsing___cVA5c0",
  "On": "GuildHeader.module__headerContainerNoBanner___cVA5c0",
  "nL": "GuildHeader.module__bannerClip___cVA5c0",
  "_e": "GuildHeader.module__bannerImage___cVA5c0",
  "Oo": "GuildHeader.module__bannerImageCentered___cVA5c0",
  "iI": "GuildHeader.module__headerGlass___cVA5c0",
  "nY": "GuildHeader.module__bannerGradient___cVA5c0",
  "VW": "GuildHeader.module__headerContent___cVA5c0",
  "KZ": "GuildHeader.module__headerFocusRing___cVA5c0",
  "w$": "GuildHeader.module__verifiedIcon___cVA5c0",
  "Ve": "GuildHeader.module__verifiedIconDefault___cVA5c0" + " " + "GuildHeader.module__verifiedIcon___cVA5c0",
  "J5": "GuildHeader.module__guildName___cVA5c0",
  "K8": "GuildHeader.module__guildNameDefault___cVA5c0" + " " + "GuildHeader.module__guildName___cVA5c0",
  "rr": "GuildHeader.module__guildNameWithBanner___cVA5c0" + " " + "GuildHeader.module__guildName___cVA5c0",
  "Rq": "GuildHeader.module__caretIcon___cVA5c0",
  "Ic": "GuildHeader.module__caretIconDefault___cVA5c0" + " " + "GuildHeader.module__caretIcon___cVA5c0",
  "Tu": "GuildHeader.module__caretIconWithBanner___cVA5c0" + " " + "GuildHeader.module__caretIcon___cVA5c0",
  "xu": "GuildHeader.module__caretIconOpen___cVA5c0",
  "_S": "GuildHeader.module__dotsIcon___cVA5c0",
  "D1": "GuildHeader.module__dotsIconDefault___cVA5c0" + " " + "GuildHeader.module__dotsIcon___cVA5c0",
  "GX": "GuildHeader.module__dotsIconWithBanner___cVA5c0" + " " + "GuildHeader.module__dotsIcon___cVA5c0",
};

module.exports = exports;
